import { GridColDef } from '@mui/x-data-grid';

export const generateColumns = (): GridColDef[] => [
  { field: 'school', headerName: 'School', width: 180 },
  { field: 'grade', headerName: 'Grade', width: 180 },
  {
    field: 'totalRolloverUsers',
    headerName: 'Total Rollover Users',
    minWidth: 220,
    flex: 1
  },
  {
    field: 'declarationsSubmittedUsers',
    headerName: 'Form Submitted',
    minWidth: 220,
    flex: 1
  },
  {
    field: 'fullPaymentSelectedUsers',
    headerName: 'Full Payment Selected',
    minWidth: 220,
    flex: 1
  },
  {
    field: 'installmentsSelectedUsers',
    headerName: 'Installments Selected',
    minWidth: 220,
    flex: 1
  },
  {
    field: 'fullPaymentPaidUsers',
    headerName: 'Full Payment Paid',
    minWidth: 220,
    flex: 1
  },
  {
    field: 'firstInstallmentPaidUsers',
    headerName: 'First Installment Paid',
    minWidth: 220,
    flex: 1
  },
  {
    field: 'enachRegisteredUsers',
    headerName: 'ENACH Registered',
    minWidth: 200,
    flex: 1
  },
  {
    field: 'pdcRegisteredUsers',
    headerName: 'PDCs Given',
    minWidth: 200,
    flex: 1
  },
  {
    field: 'paidUsersPercentage',
    headerName: 'Paid Users Percentage',
    minWidth: 180,
    flex: 1
  }
];
